import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  TouchableHighlight,
  KeyboardAvoidingView,
  ScrollView,
  Platform,
} from "react-native";
import Switch from "../components/ToggleSwitch";
import Text from "../components_v2/TextFont";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import DraggableFlatList from "react-native-draggable-flatlist";
import * as CONSTS from "../../assets/consts";
import ScenarioModel, {
  ScenarioScheduleCondition,
  ScenarioDeviceEventCondition,
  ScenarioTimeRangeCondition,
  ScenarioAction,
  ScenarioVirtual,
  ScenarioRunScenarioAction,
  ScenarioDeviceStateCondition,
  ScenarioArmedCondition,
  ScenarioAreaStateAction,
  ScenarioUserDefinedStateCondition,
} from "../viewModels/Scenario";
import * as Actions from "../actions/ScenarioActions";
import {
  faCheck,
  faEdit,
  faExclamationTriangle,
  faHandPointUp,
  faStopwatch,
} from "../../assets/consts/faCharCodes";
import { translate } from "../locales/translate";
import { ArButton } from "../argon-ui";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faPlus, faTrash } from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";

import Loading from "../components/Loading";
import {
  MainConditionSchedule,
  OptionalConditionTimeRange,
  OptionalConditionAreaArmed,
  OptionalConditionUserDefinedState,
  MainConditionDeviceGenerator,
  MainConditionDevice,
} from "../components/scenarios/conditions";
import ScenarioSection from "../components/scenarios/ScenarioSection";
import * as AreaHelper from "../actions/AreaHelper";
import AreaTree from "../components/AreaTree";
import ActionGenerator from "../components/scenarios/ActionGenerator";
import AreaStateAction from "../components/scenarios/AreaStateAction";
import ScenarioSummary from "../components/scenarios/ScenarioSummary";
import VirtualCondition from "../components/scenarios/VirtualCondition";
import RunScenarioActionPicker from "../components/scenarios/RunScenarioActionPicker";
import OptionalConditionDeviceStateGenerator from "../components/scenarios/OptionalConditionDeviceStateGenerator";
import SearchableDropDown from "../components/SearchableDropDown";
import PropTypes from "prop-types";
import { SimpleIcon } from "../components_v2/Buttons";
import SimpleDraggableItem from "../components_v2/SimpleDraggableItem";
import InputBase from "../nativeBase-ui/InputBase";
import { HStack } from "native-base";
import IntervalPicker from "../components_v2/IntervalPicker";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import ModalBase from "../nativeBase-ui/ModalBase";
import { getDir } from "../util";
const MODAL_MODES = {
  none: "none",
  conditions: "conditions",
  conditionsAfterDelay: "conditionsAfterDelay",
  areasArmCheck: "areasArmCheck",
  areasArmCheckAfterDelay: "areasArmCheckAfterDelay",
  areasUserDefinedStates: "areasUserDefinedStates",
  areasUserDefinedStatesAfterDelay: "areasUserDefinedStatesAfterDelay",
  userDefinedStates: "userDefinedStates",
  AreasActionCheck: "AreasActionCheck",
  AreaDeviceEventCheck: "AreaDeviceEventCheck",
  AreaDeviceStateCheck: "AreaDeviceStateCheck",
  AreaDeviceStateCheckAfterDelay: "AreaDeviceStateCheckAfterDelay",
  executingActionFor: "executingActionFor",
  areaActions: "areaActions",
  mainDeviceEvent: "mainDeviceEvent",
  runScenarioActions: "runScenarioActions",
  optionalDeviceState: "optionalDeviceState",
  optionalDeviceStateAfterDelay: "optionalDeviceStateAfterDelay",
  summary: "summary",
};

class ScenarioFormScreen extends Component {
  constructor(props) {
    super(props);
    let { scenarioId, mainConditionType } = this.props.navigation.state.params;
    let scenario = null;
    if (scenarioId) {
      // find from reducer or get from server
      var model = this.props.scenarioReducer.scenarios.find(
        (s) => s.id == scenarioId || s.uId == scenarioId
      );
      if (model) {
        var _s = {
          ...model,
          runScenarioActions: [...model.runScenarioActions],
          actions: [...model.actions],
          conditions: [...model.conditions],
        }; // make an immutable copy of scenario
        scenario = new ScenarioModel();
        Object.assign(scenario, _s);
        if (!mainConditionType) {
          mainConditionType = scenario._mainConditionType;
        }
      }
    } else {
      // create new
      scenario = new ScenarioModel();
      switch (mainConditionType) {
        case CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE:
          let now = new Date();
          scenario
            .addMainCondition()
            .addSchedule()
            .addDailySchedule(`${now.getHours()}:${now.getMinutes()}`, "");
          break;
        case CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE:
          scenario.addMainCondition().addDeviceEvent();
          break;
        case CONSTS.SCENARIO_CONDITIONS.MAIN_VIRTUAL:
          scenario.addMainCondition().addVirtual(faHandPointUp);
          break;
      }
    }

    scenario.hasDetail = true;
    scenario.migrateActionOrders();

    let _modalMode = MODAL_MODES.none,
      _isModalVisible = false;

    if (mainConditionType == "device" && !scenarioId) {
      // open modal at startup only in create mode, not in edit mode
      _modalMode = MODAL_MODES.AreaDeviceEventCheck;
      _isModalVisible = true;
    }

    this.allIntervalTypes = ["second", "minute", "hour"];

    this.state = {
      scenarioId,
      mainConditionType,

      isLoading: true,
      isModalVisible: _isModalVisible,

      /**
       * none : not defined, so will empty modal body
       *conditions : pick one of optional condition categories(default value),
       *areasArmCheck : tree list of areas to select one and check for armed state,
       *areasActionCheck : tree list of areas to select one and pick one action,
       *areaActions : list of actions for selected area,
       *mainDeviceEvent : form with fields required for initiating a device event main condition.
       *summary : show result summary and ask for final form confirm
       */
      modalMode: _modalMode,
      selectedAreaIdForModal: 0,
      selectedAreaUIdForModal: "",
      selectedAreaNameForModal: "",
      selectedAfterDelayConditionForModal: false,
      /**
       * the main model of view
       */
      scenario,

      accessToken: "",

      scenarioName: "",

      validation_scenarioName_hasError: false,
      validationErrors: [],
      showingValidationErrors: false,
      reOrderingActions: false,
    };

    this.rowCounter = {
      _number: 0,
      reset: () => {
        this.rowCounter._number = 0;
      },
      next: () => {
        this.rowCounter._number++;
        return this.rowCounter._number;
      },
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.ScenarioList"),
  });
  componentDidMount() {
    let { accessToken } = this.props.appReducer.currentServer;
    this.setState({ accessToken, isLoading: false });
  }

  toggleModal = (mode) => {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
      modalMode: mode || MODAL_MODES.none,
      selectedAreaIdForModal: 0,
      selectedAreaUIdForModal: "",
      selectedAreaNameForModal: "",
    });
  };

  goBack = () => {
    this.props.navigation.goBack();
  };

  save = () => {
    // console.log("this.state.scenario", this.state.scenario);
    var validationResult = this.validateForm();

    if (!validationResult.isValid) {
      // Alert.alert("", validationResult.errors.join("\r\n"));
      this.showValidationAlert();
      return;
    }
    // end of validation

    // if valid
    this.setState({
      isModalVisible: false,
      modalMode: MODAL_MODES.none,
      isLoading: true,
    });
    this.props.add(this.state.scenario, this.state.accessToken);

    this.goBack();
  };

  showValidationAlert = () => {
    this.setState({
      showingValidationErrors: true,
      isModalVisible: false,
      modalMode: MODAL_MODES.none,
    });
  };

  dismissValidationAlert = () => {
    this.setState({
      showingValidationErrors: false,
    });
  };

  validateForm = () => {
    var isValid = true;
    var errors = [];
    if (!this.state.scenario.name) {
      isValid = false;
      errors.push(
        `${translate("scenario.name")} ${translate("app.isRequired")}`
      );
    }
    // if (
    //   !this.state.scenario.nameShortcutBoard &&
    //   this.state.scenario.showDashboardShortcut
    // ) {
    //   isValid = false;
    //   errors.push(
    //     `${translate("scenario.nameShortcutBoard")} ${translate(
    //       "app.isRequired"
    //     )}`
    //   );
    // }

    if (
      this.state.scenario.actions.length == 0 &&
      this.state.scenario.runScenarioActions.length == 0 &&
      this.state.scenario.areaStateActions.length == 0
    ) {
      isValid = false;
      errors.push(`${translate("scenario.selectAtLeastOneAction")}`);
    }

    if (
      this.state.scenario.notifyByPushNotification ||
      this.state.scenario.notifyBySms
    ) {
      if (!this.state.scenario.notificationCustomMessage) {
        isValid = false;
        errors.push(`${translate("scenario.EnterNotificationCustomMessage")}`);
      }

      if (
        this.state.scenario.reverseEnabled &&
        !this.state.scenario.notificationReverseCustomMessage
      ) {
        isValid = false;
        errors.push(
          `${translate("scenario.EnterNotificationReverseCustomMessage")}`
        );
      }
    }

    this.setState({ validationErrors: errors });
    return { isValid, errors };
  };

  getActionReverseDictionary = () => {
    let actions = this.state.scenario.getActionReverse();
    let { actionManagers } = this.props.areaReducer;
    let dictionary = [];
    dictionary = AreaHelper.getActionReverseDictionary(actionManagers, actions);
    return dictionary;
  };

  render() {
    this.rowCounter.reset();
    if (this.state.isLoading) {
      return <Loading />;
    } else if (this.state.reOrderingActions) {
      return this.renderActions();
    } else {
      return (
        <KeyboardAvoidingView
          behavior="padding"
          style={{ flex: 1 }}
          enabled={true}
          keyboardVerticalOffset={0}
        >
          <ScrollView
            style={style.container}
            keyboardShouldPersistTaps="always"
          >
            <View style={{ flex: 1, marginTop: 25, alignItems: "center" }}>
              <Text style={style.screenTitle}>
                {translate(`scenario.${this.state.mainConditionType}`)}
              </Text>
              {/* information step */}
              <ScenarioSection
                number={this.rowCounter.next()}
                name={translate("scenario.information")}
              >
                <InputBase
                  label={translate("scenario.name")}
                  isInvalid={this.state.validation_scenarioName_hasError}
                  onChangeText={(txt) => {
                    let { scenario } = this.state;
                    scenario.name = txt;
                    this.setState({
                      scenario: scenario,
                      validation_scenarioName_hasError: txt.length == 0,
                    });
                  }}
                  value={this.state.scenario.name}
                  icon={faEdit}
                />
              </ScenarioSection>
              {/* end of information step */}
              {/* main condition step */}
              <ScenarioSection
                number={this.rowCounter.next()}
                name={translate("scenario.mainCondition")}
              >
                {this.renderMainCondition(
                  this.state.mainConditionType,
                  this.state.scenario.getMainCondition()
                )}
              </ScenarioSection>
              {/* end of main condition step */}
              {/* role access settings */}
              <ScenarioSection
                number={this.rowCounter.next()}
                name={translate("scenario.settings")}
              >
                {this.renderRoleAccessSettings()}
                {/* //todo === for second name in ShortcutBoard and validation input === */}
                {/* {this.state.scenario.showDashboardShortcut && (
                  <ArInput
                    icon="edit"
                    family="antdesign"
                    right
                    placeholder=""
                    error={this.state.validation_scenarioName_hasError}
                    label={translate("scenario.nameShortcutBoard")}
                    onChangeText={(txt) => {
                      let { scenario } = this.state;
                      scenario.nameShortcutBoard = txt;
                      this.setState({
                        scenario: scenario,
                        validation_scenarioName_hasError: txt.length == 0,
                      });
                    }}
                    value={this.state.scenario.nameShortcutBoard}
                  />
                )} */}
              </ScenarioSection>
              {/* end role access settings */}
              {/* optional conditions step for none virtual */}
              <ScenarioSection
                number={this.rowCounter.next()}
                name={translate("scenario.optionalConditions")}
              >
                <Text style={style.iosRtl}>
                  {translate("scenario.optionalConditions")}:
                </Text>
                {this.renderOptionalConditions(false)}
                {this.renderOptionalConditionsAddButtons(false)}
              </ScenarioSection>
              {/* end of optional conditions step */}
              {/* delay step */}
              <ScenarioSection
                number={this.rowCounter.next()}
                name={translate("scenario.delay")}
              >
                <Text>{translate("scenario.delayInMillisecond")}</Text>
                <InputBase
                  containerStyle={{ marginVertical: 10 }}
                  keyboardType="numeric"
                  placeholder={translate("app.optional")}
                  isInvalid={this.state.validation_scenarioName_hasError}
                  onChangeText={(txt) => {
                    var mill = Number(txt);
                    var model = new ScenarioModel();
                    Object.assign(model, { ...this.state.scenario });

                    model.delayMillisecond = mill || 0; //this.state.scenario.delayMillisecond;

                    this.setState({ scenario: model });
                  }}
                  value={(
                    this.state.scenario.delayMillisecond || ""
                  ).toString()}
                  icon={faStopwatch}
                />
              </ScenarioSection>
              {/* end of delay step */}
              {/* optional conditions (after delay) step for none virtual */}
              {this.state.scenario.delayMillisecond > 0 && (
                <ScenarioSection
                  number={this.rowCounter.next()}
                  name={translate("scenario.optionalConditions")}
                >
                  <Text>
                    {translate("scenario.optionalConditionsAfterDelayHeader")}:
                  </Text>
                  {this.renderOptionalConditions(true)}
                  {this.renderOptionalConditionsAddButtons(true)}
                </ScenarioSection>
              )}
              {/* end of optional conditions (after delay) step */}
              {/* actions step */}
              <ScenarioSection
                number={this.rowCounter.next()}
                name={translate("scenario.actions")}
              >
                {this.renderActions()}
                {this.renderActionsAddButtons()}
              </ScenarioSection>
              {/* end of actions step */}

              {/* reverse actions */}
              <ScenarioSection
                number={this.rowCounter.next()}
                name={translate("scenario.reverseActions")}
              >
                <View style={{ flexDirection: "row", marginTop: 20 }}>
                  <Switch
                    isOn={this.state.scenario?.reverseEnabled || false}
                    onColor={Theme.COLORS.ACTIVE}
                    offColor={Theme.COLORS.MUTED}
                    size="small"
                    onToggle={(v) => {
                      var model = { ...this.state.scenario };
                      model.reverseEnabled = v;
                      var scenario = new ScenarioModel();
                      Object.assign(scenario, model);
                      this.setState({ scenario });
                    }}
                    animationSpeed={0}
                  />
                  <Text
                    style={[style.iosRtl, { flex: 1, marginHorizontal: 5 }]}
                  >
                    {translate("scenario.reverseActions")}
                  </Text>
                </View>
                {this.state.scenario.reverseEnabled == true &&
                  this.renderReverse()}
              </ScenarioSection>
              {/* end reverse actions */}

              {/* notifications */}
              <ScenarioSection
                number={this.rowCounter.next()}
                name={translate("scenario.notifications")}
              >
                {this.renderNotificationSection()}
              </ScenarioSection>
              {/* end notifications */}

              <View style={{ marginTop: 10, width: "100%" }}>
                <ArButton
                  color="primary"
                  style={{ width: "100%" }}
                  onPress={() => {
                    this.setState({
                      modalMode: MODAL_MODES.summary,
                      isModalVisible: true,
                    });
                  }}
                >
                  {translate("app.save")}
                </ArButton>
              </View>
              {this.state.isModalVisible && (
                <ModalBase
                  isOpen={this.state.isModalVisible}
                  onClose={() => this.toggleModal()}
                  contentStyle={{ height: "100%", maxHeight: "90%" }}
                >
                  <View style={style.modalInsideWrapper}>
                    <View style={{ flex: 1 }}>
                      {this.state.modalMode == MODAL_MODES.conditions &&
                        this.renderModalInit(false)}
                      {this.state.modalMode ==
                        MODAL_MODES.conditionsAfterDelay &&
                        this.renderModalInit(true)}
                      {this.state.modalMode == MODAL_MODES.areasArmCheck &&
                        this.renderModalAreaList(
                          translate("scenario.checkAreaArmedFor"),
                          (subId, subUId) =>
                            this.handleOnAreaArmSelect(subId, subUId, false)
                        )}
                      {this.state.modalMode ==
                        MODAL_MODES.areasArmCheckAfterDelay &&
                        this.renderModalAreaList(
                          translate("scenario.checkAreaUserDefinedFor"),
                          (subId, subUId) =>
                            this.handleOnAreaArmSelect(subId, subUId, true)
                        )}
                      {this.state.modalMode ==
                        MODAL_MODES.areasUserDefinedStates &&
                        this.renderModalAreaList(
                          translate("scenario.checkAreaUserDefinedFor"),
                          (subId, subUId, subName) =>
                            this.handleOnAreaUserDefinedStateSelect(
                              subId,
                              subUId,
                              subName,
                              false
                            )
                        )}
                      {this.state.modalMode ==
                        MODAL_MODES.areasUserDefinedStatesAfterDelay &&
                        this.renderModalAreaList(
                          translate("scenario.checkAreaUserDefinedFor"),
                          (subId, subUId, subName) =>
                            this.handleOnAreaUserDefinedStateSelect(
                              subId,
                              subUId,
                              subName,
                              true
                            )
                        )}
                      {this.state.modalMode == MODAL_MODES.AreasActionCheck &&
                        this.renderModalAreaList(
                          translate("scenario.executingActionFor"),
                          (subId, subUId, subName) =>
                            this.handleOnAreaActionSelect(
                              subId,
                              subUId,
                              subName
                            )
                        )}
                      {this.state.modalMode ==
                        MODAL_MODES.AreaDeviceEventCheck &&
                        this.renderModalAreaList(
                          translate("scenario.checkAreaForEvent"),
                          (subId, subUId, subName) => {
                            this.handleOnAreaDeviceEventSelect(
                              subId,
                              subUId,
                              subName
                            );
                          }
                        )}
                      {this.state.modalMode ==
                        MODAL_MODES.AreaDeviceStateCheck &&
                        this.renderModalAreaList(
                          translate("scenario.checkAreaForState"),
                          (subId, subUId, subName) => {
                            this.handleOnAreaDeviceStateSelect(
                              subId,
                              subUId,
                              subName,
                              false
                            );
                          }
                        )}
                      {this.state.modalMode == MODAL_MODES.userDefinedStates &&
                        this.renderModalUserDefinedStates()}
                      {this.state.modalMode ==
                        MODAL_MODES.AreaDeviceStateCheckAfterDelay &&
                        this.renderModalAreaList(
                          translate("scenario.checkAreaForState"),
                          (subId, subUId, subName) => {
                            this.handleOnAreaDeviceStateSelect(
                              subId,
                              subUId,
                              subName,
                              true
                            );
                          }
                        )}
                      {this.state.modalMode == MODAL_MODES.areaActions &&
                        this.renderModalAreaAction()}
                      {this.state.modalMode == MODAL_MODES.mainDeviceEvent &&
                        this.renderModalMainDeviceEvent()}
                      {this.state.modalMode == MODAL_MODES.runScenarioActions &&
                        this.renderModalRunScenarioActions()}
                      {this.state.modalMode ==
                        MODAL_MODES.optionalDeviceState &&
                        this.renderModalOptionalDeviceState(false)}
                      {this.state.modalMode ==
                        MODAL_MODES.optionalDeviceStateAfterDelay &&
                        this.renderModalOptionalDeviceState(true)}
                      {this.state.modalMode == MODAL_MODES.summary &&
                        this.renderModalSummary()}
                    </View>
                    {/* {this.state.modalMode != MODAL_MODES.summary && (
                      <ArButton
                        color="muted"
                        variant="outline"
                        style={[style.modalButton]}
                        onPress={this.toggleModal}
                      >
                        {translate("app.cancel")}
                      </ArButton>
                    )} */}
                  </View>
                </ModalBase>
              )}
            </View>
          </ScrollView>
          {/** validation alert */}
          {this.state.showingValidationErrors && (
            <AlertDialogBase
              isOpen={true}
              cancelText={translate("app.close")}
              cancelVariant="outline"
              onClose={() => this.dismissValidationAlert()}
            >
              <Text>{" - " + this.state.validationErrors.join("\r\n - ")}</Text>
            </AlertDialogBase>
          )}
        </KeyboardAvoidingView>
      );
    }
  }

  /**
   * pick an area to check if is armed or not
   */
  handleOnAreaArmSelect = (subId, subUId, afterDelayCondition = false) => {
    var allAreas = this.props.areaReducer.areas;
    var model = new ScenarioModel();
    Object.assign(model, { ...this.state.scenario });
    var area = AreaHelper.findAreaById(allAreas, subId || subUId);
    if (area) {
      model
        .addOptionalCondition()
        .addAreaArmedState(
          subId,
          subUId,
          area.areaName,
          true,
          afterDelayCondition
        );
    }
    this.setState({
      Scenario: model,
      modalMode: MODAL_MODES.conditions,
      isModalVisible: false,
    });
  };

  /**
   * pick an area to check if is user defined state is activate or not
   */
  handleOnAreaUserDefinedStateSelect = (
    subId,
    subUId,
    subName,
    afterDelayCondition = false
  ) => {
    var allAreas = this.props.areaReducer.areas;
    var model = new ScenarioModel();
    Object.assign(model, { ...this.state.scenario });
    var area = AreaHelper.findAreaById(allAreas, subId || subUId);
    // if (area) {
    //   model
    //     .addOptionalCondition()
    //     .addAreaUserDefinedState(subId, area.areaName, true, afterDelayCondition);
    // }
    this.setState({
      modalMode: MODAL_MODES.userDefinedStates,
      selectedAreaIdForModal: subId,
      selectedAreaUIdForModal: subUId,
      selectedAreaNameForModal: subName,
      selectedAfterDelayConditionForModal: afterDelayCondition,
    });
  };

  handleOnAreaActionSelect = (subId, subUId, subName) => {
    this.setState({
      modalMode: MODAL_MODES.areaActions,
      selectedAreaIdForModal: subId,
      selectedAreaUIdForModal: subUId,
      selectedAreaNameForModal: subName,
    });
  };

  handleOnAreaDeviceEventSelect = (subId, subUId, subName) => {
    this.setState({
      modalMode: MODAL_MODES.mainDeviceEvent,
      selectedAreaIdForModal: subId,
      selectedAreaUIdForModal: subUId,
      selectedAreaNameForModal: subName,
    });
  };

  handleOnAreaDeviceStateSelect = (
    subId,
    subUId,
    subName,
    afterDelayCondition
  ) => {
    this.setState({
      modalMode: afterDelayCondition
        ? MODAL_MODES.optionalDeviceStateAfterDelay
        : MODAL_MODES.optionalDeviceState,
      selectedAreaIdForModal: subId,
      selectedAreaUIdForModal: subUId,
      selectedAreaNameForModal: subName,
    });
  };

  manuallyChangeActionsSort = (from, to) => {
    var scenario = new ScenarioModel();
    Object.assign(scenario, this.state.scenario);
    scenario.reOrderActions(from, to);
    this.setState({ scenario });
  };

  renderMainCondition = (mainConditionType, conditionModel) => {
    // === goBack for time unselected area or device in deviceConditions ===
    if (!conditionModel && this.state.modalMode === MODAL_MODES.none) {
      this.goBack();
    }
    if (!conditionModel) {
      return <Text>conditionModel is null or undefined</Text>;
    }
    switch (mainConditionType) {
      case CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE:
        let schedule = new ScenarioScheduleCondition();
        Object.assign(schedule, conditionModel);
        if (Number(schedule.id) > 0) {
          schedule.tempId = schedule.id;
        }
        return (
          <MainConditionSchedule
            id={schedule.tempId}
            time={schedule.time}
            repeatType={schedule.scheduleType}
            repeatInterval={schedule.customRepeatInterval}
            repeatIntervalType={schedule.customRepeatType}
            daysOfWeek={schedule.daysOfWeek}
            style={style.mainConditionWrapper}
            onDaysOfWeeksChange={(days) => {
              var c = this.state.scenario.findConditionById(
                schedule.tempId,
                CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE
              );
              c.daysOfWeek = days;
              this.setState({ scenario: this.state.scenario });
            }}
            onCustomRepeatChanged={(interval, type) => {
              var c = this.state.scenario.findConditionById(
                schedule.tempId,
                CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE
              );
              c.customRepeatInterval = interval;
              c.customRepeatType = type;
              this.setState({ scenario: this.state.scenario });
            }}
            onTimeChange={(time) => {
              {
                var c = this.state.scenario.findConditionById(
                  schedule.tempId,
                  CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE
                );
                c.time = time;
                this.setState({ scenario: this.state.scenario });
              }
            }}
            onRepeatTypeChange={(type) => {
              var c = this.state.scenario.findConditionById(
                schedule.tempId,
                CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE
              );
              c.scheduleType = type;
              this.setState({ scenario: this.state.scenario });
            }}
          />
        );
      case CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE:
        let deviceCondition = new ScenarioDeviceEventCondition();
        Object.assign(deviceCondition, conditionModel);
        if (Number(deviceCondition.id) > 0) {
          deviceCondition.tempId = deviceCondition.id;
        }
        return (
          <MainConditionDevice
            model={deviceCondition}
            // onPress={(id) => {}}
            ignoreEventsIntervalValue={
              deviceCondition.ignoreEventsIntervalValue || 0
            }
            ignoreEventsIntervalType={
              deviceCondition.ignoreEventsIntervalType || "second"
            }
            onChangeIgnoreEventsIntervalType={(value) => {
              var model = { ...this.state.scenario };
              var findCondition = model.conditions.find(
                (condition) =>
                  condition.id === deviceCondition.id ||
                  condition.uId === deviceCondition.uId
              );
              if (findCondition) {
                findCondition.ignoreEventsIntervalType =
                  value.toString() || "second";
                model.conditions[model.conditions.indexOf(findCondition)] =
                  findCondition;
                var scenario = new ScenarioModel();
                Object.assign(scenario, model);
                this.setState({ scenario });
              }
            }}
            onChangeIgnoreEventsIntervalValue={(value) => {
              var model = { ...this.state.scenario };
              var findCondition = model.conditions.find(
                (condition) =>
                  condition.id === deviceCondition.id ||
                  condition.uId === deviceCondition.uId
              );
              if (findCondition) {
                findCondition.ignoreEventsIntervalValue = Number(value) || 0;
                model.conditions[model.conditions.indexOf(findCondition)] =
                  findCondition;
                var scenario = new ScenarioModel();
                Object.assign(scenario, model);
                this.setState({ scenario });
              }
            }}
          />
        );
      case CONSTS.SCENARIO_CONDITIONS.MAIN_VIRTUAL:
        let virtual = new ScenarioVirtual();
        Object.assign(virtual, conditionModel);
        if (Number(virtual.id) > 0) {
          virtual.tempId = virtual.id;
        }

        return (
          <VirtualCondition
            initIcon={virtual.iconName || ""}
            onIconSelect={(iconName = "question") => {
              var v = this.state.scenario.findConditionById(
                virtual.tempId,
                CONSTS.SCENARIO_CONDITIONS.MAIN_VIRTUAL
              );
              v.iconName = iconName;
              this.setState({ scenario: this.state.scenario }, () => {
                // console.log(
                // "scenario model in scenarioForm VirtualCondiotion",
                // this.state.scenario)
              });
            }}
          />
        );
      default:
        return <Text>not supported</Text>;
    }
  };

  renderOptionalConditions = (afterDelayConditions = false) => {
    let conditions =
      this.state.scenario.getOptionalConditions(afterDelayConditions);
    if (conditions.length > 0) {
      return (
        <View>
          {conditions.map((c, i) => {
            switch (c.baseType) {
              case CONSTS.SCENARIO_CONDITIONS.OPTIONAL_TIME_RANGE:
                var timeRange = new ScenarioTimeRangeCondition();
                Object.assign(timeRange, c);
                if (Number(timeRange.id) > 0) {
                  timeRange.tempId = timeRange.id;
                }
                return (
                  <OptionalConditionTimeRange
                    key={i}
                    id={timeRange.id || timeRange.tempId}
                    from={timeRange.timeStateStart}
                    to={timeRange.timeStateEnd}
                    onFromChanged={(time) => {
                      var model = new ScenarioModel();
                      Object.assign(model, this.state.scenario);
                      model.setTimeRangeCondition(
                        timeRange.id || timeRange.tempId,
                        time,
                        "start"
                      );
                    }}
                    onToChanged={(time) => {
                      var model = new ScenarioModel();
                      Object.assign(model, { ...this.state.scenario });
                      model.setTimeRangeCondition(
                        timeRange.id || timeRange.tempId,
                        time,
                        "end"
                      );
                    }}
                    onDelete={(id) => {
                      var model = new ScenarioModel();
                      Object.assign(model, { ...this.state.scenario });
                      model.removeCondition(id, timeRange.baseType);
                      this.setState({ scenario: model });
                    }}
                  />
                );
              case CONSTS.SCENARIO_CONDITIONS.OPTIONAL_AREA_ARMED:
                let armed = new ScenarioArmedCondition(
                  CONSTS.SCENARIO_CONDITIONS.OPTIONAL_AREA_ARMED
                );
                Object.assign(armed, c);
                if (Number(armed.id) > 0) {
                  armed.tempId = armed.id;
                }

                return (
                  <OptionalConditionAreaArmed
                    key={i}
                    id={armed.id || armed.tempId}
                    areaId={armed.areaIdArmCheck}
                    areaName={armed.areaNameArmCheck}
                    areaExpected={armed.areaArmCheckExpected}
                    onExpectationChange={(expected) => {
                      var c = this.state.scenario.findConditionById(
                        armed.id || armed.tempId,
                        CONSTS.SCENARIO_CONDITIONS.OPTIONAL_AREA_ARMED
                      );
                      c.areaArmCheckExpected = expected;
                      this.setState({ scenario: this.state.scenario });
                    }}
                    onDelete={(id) => {
                      var model = new ScenarioModel();
                      Object.assign(model, { ...this.state.scenario });
                      model.removeCondition(id, armed.baseType);
                      this.setState({ scenario: model });
                    }}
                  />
                );
              case CONSTS.SCENARIO_CONDITIONS.OPTIONAL_DEVICE_STATE:
                let stt = new ScenarioDeviceStateCondition();
                Object.assign(stt, c);
                if (Number(stt.id) > 0) {
                  stt.tempId = stt.id;
                }
                return (
                  <SimpleRemovableItem
                    key={i}
                    text={stt.getSummary()}
                    onDelete={() => {
                      let { scenario } = this.state;
                      var model = new ScenarioModel();
                      Object.assign(model, scenario);
                      model.removeCondition(stt.tempId, stt.baseType);
                      this.setState({ scenario: model });
                    }}
                  />
                );
              case CONSTS.SCENARIO_CONDITIONS.OPTIONAL_USER_DEFINED_STATE:
                let userState = new ScenarioUserDefinedStateCondition(
                  CONSTS.SCENARIO_CONDITIONS.OPTIONAL_USER_DEFINED_STATE
                );
                Object.assign(userState, c);
                if (Number(userState.id) > 0) {
                  userState.tempId = userState.id;
                }
                return (
                  <OptionalConditionUserDefinedState
                    key={i}
                    id={userState.id || userState.tempId}
                    areaId={userState.areaId}
                    areaUId={userState.areaUId}
                    areaName={userState.areaName}
                    stateId={userState.stateId}
                    stateUId={userState.stateUId}
                    stateName={userState.stateName}
                    expectedActivation={userState.expectedActivation}
                    onExpectationChange={(expected) => {
                      var c = this.state.scenario.findConditionById(
                        userState.id || userState.tempId,
                        CONSTS.SCENARIO_CONDITIONS.OPTIONAL_USER_DEFINED_STATE
                      );
                      c.expectedActivation = expected;
                      this.setState({ scenario: this.state.scenario });
                    }}
                    onDelete={(id) => {
                      var model = new ScenarioModel();
                      Object.assign(model, { ...this.state.scenario });
                      model.removeCondition(id, userState.baseType);
                      this.setState({ scenario: model });
                    }}
                  />
                );
              default:
                return <Text key={i}>{c.baseType} not supported</Text>;
            }
          })}
        </View>
      );
    }
  };

  renderOptionalConditionsAddButtons = (afterDelayConditions = false) => {
    let conditions =
      this.state.scenario.getOptionalConditions(afterDelayConditions);
    if (conditions.length == 0) {
      return (
        <ArButton
          icon={faPlus}
          style={{ marginTop: 10 }}
          onPress={() =>
            this.toggleModal(
              afterDelayConditions
                ? MODAL_MODES.conditionsAfterDelay
                : MODAL_MODES.conditions
            )
          }
        >
          {/* <FontAwesomeIcon icon={faPlus} color="#FFF" /> */}
          {translate("scenario.andAlsoIf")}
        </ArButton>
      );
    } else if (conditions.length == 1) {
      return (
        <HStack space={2} p="1.5" style={{ direction: getDir() }}>
          <ArButton
            icon={faPlus}
            style={{ flex: 1 }}
            onPress={() => {
              var model = new ScenarioModel();
              Object.assign(model, { ...this.state.scenario });
              if (afterDelayConditions) {
                model.afterDelayCompositionType = "AND";
              } else {
                model.compositionType = "AND";
              }
              this.setState({ scenario: model });
              this.toggleModal(
                afterDelayConditions
                  ? MODAL_MODES.conditionsAfterDelay
                  : MODAL_MODES.conditions
              );
            }}
          >
            {translate("scenario.andAlsoIf")}
          </ArButton>
          <ArButton
            color="primary"
            icon={faPlus}
            variant="outline"
            iconColor={Theme.COLORS.PRIMARY}
            onPress={() => {
              var model = new ScenarioModel();
              Object.assign(model, { ...this.state.scenario });
              if (afterDelayConditions) {
                model.afterDelayCompositionType = "OR";
              } else {
                model.compositionType = "OR";
              }
              this.setState({ scenario: model });
              this.toggleModal(
                afterDelayConditions
                  ? MODAL_MODES.conditionsAfterDelay
                  : MODAL_MODES.conditions
              );
            }}
            style={{ flex: 1 }}
          >
            {translate("scenario.orIf")}
          </ArButton>
        </HStack>
      );
    } else {
      return (
        <ArButton
          icon={faPlus}
          style={{ marginTop: 10 }}
          onPress={() => {
            this.toggleModal(
              afterDelayConditions
                ? MODAL_MODES.conditionsAfterDelay
                : MODAL_MODES.conditions
            );
          }}
        >
          {afterDelayConditions == false &&
            (this.state.scenario.compositionType == "AND"
              ? translate("scenario.andAlsoIf")
              : translate("scenario.orIf"))}
          {afterDelayConditions == true &&
            (this.state.scenario.afterDelayCompositionType == "AND"
              ? translate("scenario.andAlsoIf")
              : translate("scenario.orIf"))}
        </ArButton>
      );
    }
  };

  renderRoleAccessSettings = () => {
    var s = this.state.scenario;
    var model = new ScenarioModel();
    Object.assign(model, s);
    if (model.rolesAllowedExecute) {
      model._allowedRoles = model.rolesAllowedExecute.split(",");
    }
    return (
      <View>
        <Text style={style.iosRtl}>{translate("scenario.whoCanExecute")}</Text>
        {/* admin switch */}
        <View style={{ flexDirection: "row", marginTop: 20 }}>
          <Switch
            isOn={true}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {}}
            animationSpeed={0}
          />
          <Text style={[style.iosRtl, { flex: 1, marginHorizontal: 5 }]}>
            {translate("user.role.admin")}
          </Text>
        </View>
        {/* end admin switch */}
        {/* member switch */}
        <View style={{ flexDirection: "row", marginTop: 20 }}>
          <Switch
            isOn={model._allowedRoles.includes("Member")}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {
              if (v) {
                model.AddAllowedRole("Member");
              } else {
                model.RemoveAllowedRole("Member");
              }
              this.setState({ scenario: model });
            }}
            animationSpeed={0}
          />
          <Text style={[style.iosRtl, { flex: 1, marginHorizontal: 5 }]}>
            {translate("user.role.member")}
          </Text>
        </View>
        {/* end member switch */}
        {/* guest switch */}
        <View style={{ flexDirection: "row", marginTop: 20 }}>
          <Switch
            isOn={model._allowedRoles.includes("Guest")}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {
              if (v) {
                model.AddAllowedRole("Guest");
              } else {
                model.RemoveAllowedRole("Guest");
              }
              this.setState({ scenario: model });
            }}
            animationSpeed={0}
          />
          <Text style={[style.iosRtl, { flex: 1, marginHorizontal: 5 }]}>
            {translate("user.role.guest")}
          </Text>
        </View>
        {/* end guest switch */}
        <View
          style={{
            flexDirection: "row",
            marginTop: 20,
            paddingVertical: 15,
            borderTopColor: Theme.COLORS.BORDER,
            borderTopWidth: 1,
          }}
        >
          <Switch
            isOn={model.showDashboardShortcut}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {
              model.setShowDashboardShortcut(v);
              this.setState({ scenario: model });
            }}
            animationSpeed={0}
          />
          <Text style={[style.iosRtl, { flex: 1, marginHorizontal: 5 }]}>
            {translate("scenario.ShowDashboardShortcut")}
          </Text>
        </View>
      </View>
    );
  };

  renderNotificationSection = () => {
    var s = this.state.scenario;
    var model = new ScenarioModel();
    Object.assign(model, s);
    if (model.rolesReceiveNotification) {
      model._rolesReceiveNotification =
        model.rolesReceiveNotification.split(",");
    }
    var CUSTOM_MESSAGE_MAX_LEN = 100;
    return (
      <View>
        <Text style={style.iosRtl}>
          {translate("scenario.notificationTitle")}
        </Text>
        {/**notification toggle */}
        <View style={{ flexDirection: "row", marginTop: 20 }}>
          <Switch
            isOn={this.state.scenario.notifyByPushNotification}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {
              var s = this.state.scenario;
              var model = new ScenarioModel();
              Object.assign(model, s);
              model.notifyByPushNotification = v;
              this.setState({ scenario: model });
            }}
            animationSpeed={0}
          />
          <Text style={[style.iosRtl, { flex: 1, marginHorizontal: 5 }]}>
            {translate("scenario.appNotification")}
          </Text>
        </View>
        {/**sms toggle */}
        <View style={{ flexDirection: "row", marginTop: 20 }}>
          <Switch
            isOn={this.state.scenario.notifyBySms}
            onColor={Theme.COLORS.ACTIVE}
            offColor={Theme.COLORS.MUTED}
            size="small"
            onToggle={(v) => {
              var s = this.state.scenario;
              var model = new ScenarioModel();
              Object.assign(model, s);
              model.notifyBySms = v;
              this.setState({ scenario: model });
            }}
            animationSpeed={0}
          />
          <Text style={[style.iosRtl, { flex: 1, marginHorizontal: 5 }]}>
            {translate("scenario.sms")}
          </Text>
        </View>
        {/**receiver toggles */}
        {(model.notifyByPushNotification || model.notifyBySms) && (
          <View
            style={{
              backgroundColor: "#FFF",
              flex: 1,
              padding: 10,
              marginTop: 15,
            }}
          >
            <Text style={style.iosRtl}>
              {translate("scenario.notificationReceivers")}:
            </Text>
            {["Me", "Admin", "Member", "Guest"].map((role) => {
              return (
                <View
                  key={role}
                  style={{ flexDirection: "row", marginTop: 20 }}
                >
                  <Switch
                    isOn={model._rolesReceiveNotification.indexOf(role) >= 0}
                    onColor={Theme.COLORS.ACTIVE}
                    offColor={Theme.COLORS.MUTED}
                    size="small"
                    onToggle={(v) => {
                      var s = this.state.scenario;
                      var model = new ScenarioModel();
                      Object.assign(model, s);
                      if (v) {
                        model.AddNotificationReceiverRole(role);
                      } else {
                        model.RemoveNotificationReceiverRole(role);
                      }
                      this.setState({ scenario: model });
                    }}
                    animationSpeed={0}
                  />
                  <Text
                    style={[style.iosRtl, { flex: 1, marginHorizontal: 5 }]}
                  >
                    {translate(`user.role.${role.toLowerCase()}`)}
                  </Text>
                </View>
              );
            })}
          </View>
        )}
        {/**custom messages */}
        {(model.notifyByPushNotification || model.notifyBySms) && (
          <View>
            <View style={{ marginVertical: 10 }}>
              <Text style={style.iosRtl}>
                {translate("scenario.notificationCustomMessage")}
                {this.state.scenario.notificationCustomMessage &&
                  this.state.scenario.notificationCustomMessage.length > 0 && (
                    <Text
                      style={{
                        color: Theme.COLORS.MUTED,
                        paddingHorizontal: 5,
                        fontSize: 10,
                      }}
                    >
                      {"  "}(
                      {this.state.scenario.notificationCustomMessage.length}/
                      {CUSTOM_MESSAGE_MAX_LEN})
                    </Text>
                  )}
              </Text>
              <InputBase
                containerStyle={{ marginVertical: 10 }}
                onChangeText={(txt) => {
                  if (txt.length <= CUSTOM_MESSAGE_MAX_LEN) {
                    var model = { ...this.state.scenario };
                    var scenario = new ScenarioModel();
                    Object.assign(scenario, model);
                    scenario.setNotificationCustomMessage(txt);
                    this.setState({ scenario });
                  }
                }}
                value={this.state.scenario.notificationCustomMessage}
              />
              <Text
                style={[
                  style.iosRtl,
                  {
                    backgroundColor: "#999",
                    color: "#FFF",
                    padding: 5,
                    marginBottom: 20,
                    borderRadius: 5,
                  },
                ]}
              >
                <Text
                  style={[style.iosRtl, { fontWeight: "bold", fontSize: 14 }]}
                >
                  {translate("app.preview")}:
                </Text>
                {"\r\n"}
                {"\r\n"}
                <Text style={style.iosRtl}>{translate("scenario.alert")}</Text>
                {"\r\n"}
                <Text style={style.iosRtl}>
                  {this.state.scenario.notificationCustomMessage ||
                    this.state.scenario.name}
                </Text>
              </Text>
            </View>
            {model.reverseEnabled && (
              <View>
                <Text style={style.iosRtl}>
                  {translate("scenario.notificationReverseCustomMessage")}
                  {this.state.scenario.notificationReverseCustomMessage &&
                    this.state.scenario.notificationReverseCustomMessage
                      .length > 0 && (
                      <Text
                        style={{
                          color: Theme.COLORS.MUTED,
                          paddingHorizontal: 5,
                          fontSize: 10,
                        }}
                      >
                        {"  "}(
                        {
                          this.state.scenario.notificationReverseCustomMessage
                            .length
                        }
                        /{CUSTOM_MESSAGE_MAX_LEN})
                      </Text>
                    )}
                </Text>
                <InputBase
                  containerStyle={{ marginVertical: 10 }}
                  onChangeText={(txt) => {
                    if (txt.length <= CUSTOM_MESSAGE_MAX_LEN) {
                      var model = { ...this.state.scenario };
                      var scenario = new ScenarioModel();
                      Object.assign(scenario, model);
                      scenario.setNotificationReverseCustomMessage(txt);
                      this.setState({ scenario });
                    }
                  }}
                  value={this.state.scenario.notificationReverseCustomMessage}
                />
                <Text
                  style={[
                    style.iosRtl,
                    {
                      backgroundColor: "#999",
                      color: "#FFF",
                      padding: 5,
                      marginBottom: 20,
                      borderRadius: 5,
                    },
                  ]}
                >
                  <Text
                    style={[style.iosRtl, { fontWeight: "bold", fontSize: 14 }]}
                  >
                    {translate("app.preview")}:
                  </Text>
                  {"\r\n"}
                  {"\r\n"}
                  <Text style={style.iosRtl}>
                    {translate("scenario.alert")}
                  </Text>
                  {"\r\n"}
                  <Text style={style.iosRtl}>
                    {this.state.scenario.notificationReverseCustomMessage ||
                      this.state.scenario.name}
                  </Text>
                </Text>
              </View>
            )}
          </View>
        )}
      </View>
    );
  };

  renderActionItem = (act, idx, isActive, drag) => {
    var canDrag = typeof drag === "function";
    if (isActive == undefined) isActive = false;
    // areaStateActions
    if (
      (act.stateId > 0 || act.stateUId !== "") &&
      act.manager === "AreaStateManager"
    ) {
      var arsModel = new ScenarioAreaStateAction();
      Object.assign(arsModel, act);
      return (
        <SimpleDraggableItem
          key={idx}
          number={idx + 1}
          onDragAreaPress={drag}
          onManuallyChange={(from, to) => {
            this.manuallyChangeActionsSort(from, to);
          }}
          isDragging={isActive}
          canDrag={canDrag}
        >
          <AreaStateAction
            id={arsModel.tempId}
            stateName={arsModel.stateName}
            areaName={arsModel.areaName}
            action={act.action}
            overrideAutoDisableDuration={arsModel.autoDisableIntervalDuration}
            overrideAutoDisableType={arsModel.autoDisableIntervalType}
            shouldOverrideAutoDisable={arsModel.shouldOverrideAutoDisable}
            onOverrideAutoDisableChange={(
              shouldOverrideAutoDisable,
              overrideAutoDisableType,
              overrideAutoDisableDuration
            ) => {
              var scenario = new ScenarioModel();
              Object.assign(scenario, { ...this.state.scenario });
              var act = { ...arsModel };
              act.shouldOverrideAutoDisable = shouldOverrideAutoDisable;
              act.autoDisableIntervalType = overrideAutoDisableType;
              act.autoDisableIntervalDuration = overrideAutoDisableDuration;
              scenario.updateAreaStateAutoDisable(
                act.id,
                act.tempId,
                act.shouldOverrideAutoDisable,
                act.autoDisableIntervalDuration,
                act.autoDisableIntervalType
              );

              this.setState({ scenario });
            }}
            onDelete={() => {
              var scenario = new ScenarioModel();
              Object.assign(scenario, { ...this.state.scenario });
              var sttIdx = scenario.areaStateActions.indexOf(act);
              scenario.removeAreaStateAction(arsModel.stateId);
              this.setState({ scenario });
            }}
          />
        </SimpleDraggableItem>
      );
    }
    // runScenarioActions
    else if (act.scenarioToRunId > 0) {
      var scnModel = new ScenarioRunScenarioAction();
      Object.assign(scnModel, act);

      return (
        <SimpleDraggableItem
          key={idx}
          number={idx + 1}
          onDragAreaPress={drag}
          isDragging={isActive}
          canDrag={canDrag}
          onManuallyChange={(from, to) => {
            this.manuallyChangeActionsSort(from, to);
          }}
        >
          <SimpleRemovableItem
            key={idx}
            text={translate("scenario.runScenarioActionMessage", {
              scenarioName: scnModel.scenarioName,
            })}
            onDelete={() => {
              var model = new ScenarioModel();
              var { scenario } = this.state;
              Object.assign(model, scenario);
              model.removeRunScenarioAction(act.scenarioToRunId);
              this.setState({ scenario: model });
            }}
          />
        </SimpleDraggableItem>
      );
    }
    // simple action
    else {
      var actModel = new ScenarioAction();
      Object.assign(actModel, act);
      if (
        actModel.parameters.length > 0 &&
        actModel.parameters.length == actModel.parameterTypes.length
      ) {
        if (actModel.action == "SendToFloor") {
          try {
            var _floorId = actModel.parameters[0];
            var elv = this.props.deviceReducer.list.filter(
              (d) =>
                d.deviceType == DeviceTypes.ELEVATOR &&
                d.elevatorFloors &&
                d.elevatorFloors.some((ef) => ef.id == _floorId)
            )[0];
            if (elv) {
              var floor = elv.elevatorFloors.filter(
                (ef) => ef.id == _floorId
              )[0];
              if (floor) {
                actModel.setParameterAlt(0, floor.label);
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
      }

      var simpleActionSummary = actModel.getSummary();

      return (
        <SimpleDraggableItem
          key={idx}
          number={idx + 1}
          onDragAreaPress={drag}
          isDragging={isActive}
          canDrag={canDrag}
          onManuallyChange={(from, to) => {
            this.manuallyChangeActionsSort(from, to);
          }}
        >
          <SimpleRemovableItem
            key={idx}
            text={simpleActionSummary}
            onDelete={() => {
              {
                var scenarioM = new ScenarioModel();
                Object.assign(scenarioM, { ...this.state.scenario });
                scenarioM.removeAction(actModel.id || actModel.tempId);
                this.setState({ scenario: scenarioM });
              }
            }}
          />
        </SimpleDraggableItem>
      );
    }
  };

  renderActions = () => {
    var scenario = new ScenarioModel();
    Object.assign(scenario, this.state.scenario);
    var actionsToRender = scenario.getAllActions();
    // console.log(`actionsToRender`, actionsToRender)
    if (this.state.reOrderingActions) {
      // if (Platform.OS == "web") {
      //   return (
      //     <View>
      //       {actionsToRender.map((act, idx) => {
      //         return this.renderActionItem(act, idx, false, () => {});
      //       })}
      //     </View>
      //   );
      // } else {
      return (
        <View style={{ flex: 1, padding: 5 }}>
          <Text
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 18,
              marginVertical: 5,
            }}
          >
            {translate("scenario.actions")}
          </Text>
          <ArButton
            color="success"
            style={{
              ...style.optionalConditionAddButton,
              width: 50,
              alignSelf: "flex-end",
            }}
            onPress={() =>
              this.setState({
                reOrderingActions: false,
              })
            }
          >
            <View
              style={{
                flexDirection: "row-reverse",
              }}
            >
              <FontAwesomeIcon icon={faCheck} color="#FFF" />
              <Text style={{ color: "#FFF" }}> {translate("app.confirm")}</Text>
            </View>
          </ArButton>

          <DraggableFlatList
            data={actionsToRender}
            keyExtractor={(item, idx) => idx.toString()}
            onDragEnd={(dragData) => {
              this.manuallyChangeActionsSort(dragData.from, dragData.to);
            }}
            renderItem={({ item, index, drag, isActive }) => {
              var act = item;
              var idx = index;
              return this.renderActionItem(act, idx, isActive, drag);
            }}
          />
        </View>
      );
      //}
    } else {
      return (
        <View style={{ flex: 1 }}>
          {this.state.scenario.getActionsCount() > 1 && (
            <ArButton
              color="success"
              style={{
                ...style.optionalConditionAddButton,
                minWidth: 90,
              }}
              onPress={() =>
                this.setState({
                  reOrderingActions: true,
                })
              }
            >
              <View
                style={{
                  flexDirection: "row-reverse",
                }}
              >
                <FontAwesomeIcon icon={faEdit} color="#FFF" />
                <Text style={{ color: "#FFF", marginHorizontal: 5 }}>
                  {" "}
                  {translate("scenario.reOrderActions")}
                </Text>
              </View>
            </ArButton>
          )}
          {actionsToRender.map((act, idx) => {
            return this.renderActionItem(act, idx);
          })}
        </View>
      );
    }
  };

  renderActionsAddButtons = () => {
    return (
      <HStack space={2} p="1.5" style={{ direction: getDir() }}>
        <ArButton
          icon={faPlus}
          style={{ flex: 1 }}
          onPress={() =>
            this.setState({
              modalMode: MODAL_MODES.AreasActionCheck,
              isModalVisible: true,
            })
          }
        >
          {translate("scenario.newAction")}
        </ArButton>
        <ArButton
          color="primary"
          icon={faPlus}
          variant="outline"
          iconColor={Theme.COLORS.PRIMARY}
          onPress={() => {
            this.toggleModal(MODAL_MODES.runScenarioActions);
          }}
          style={{ flex: 1 }}
        >
          {translate("scenario.newScenarioAction")}
        </ArButton>
      </HStack>
    );
  };

  renderReverse = () => {
    let { reverseIntervalValue, reverseIntervalType } = this.state.scenario;
    let dictionary = this.getActionReverseDictionary();
    var reverseSummaries = [];
    var irreversibleSummaries = [];
    var allActions = this.state.scenario.getActionReverse();
    if (allActions.length > 0) {
      for (var i in allActions) {
        var action = allActions[i];
        var hasReverse = dictionary.some((d) => {
          return d.manager == action.manager && d.action == action.action;
        });
        if (hasReverse) {
          reverseSummaries.push(action.getSummary(true, dictionary));
        } else {
          var irreversibleSummary = `${action.manager}.${action.action}`;
          if (!irreversibleSummaries.includes(irreversibleSummary)) {
            irreversibleSummaries.push(irreversibleSummary);
          }
        }
      }
    }
    if (!reverseIntervalType) reverseIntervalType = "second";

    var reverseScenarioSummaries = this.state.scenario
      .getRunScenarioActions()
      .filter((s) => s.reverseEnabled)
      .map((s) => s.scenarioName);

    return (
      <View style={{ marginStart: 15 }}>
        {/* interval picker */}
        <IntervalPicker
          helpText={translate("scenario.reverseActionsHelp", {
            interval: reverseIntervalValue,
            intervalType: translate(`timer.${reverseIntervalType}`),
          })}
          data={this.allIntervalTypes}
          valueInput={reverseIntervalValue}
          valueSelect={reverseIntervalType || this.allIntervalTypes[0]}
          onChangeText={(txt) => {
            var model = { ...this.state.scenario };
            model.reverseIntervalValue = Number(txt) || 0;
            var scenario = new ScenarioModel();
            Object.assign(scenario, model);
            this.setState({ scenario });
          }}
          onChangeSelect={(value, index, data) => {
            var model = { ...this.state.scenario };
            model.reverseIntervalType = value.toString();
            var scenario = new ScenarioModel();
            Object.assign(scenario, model);
            this.setState({ scenario });
          }}
        />
        {reverseSummaries.length > 0 && (
          <View>
            {reverseSummaries.map((r) => (
              <View style={style.simpleRemovableWrapper}>
                <Text>{r}</Text>
              </View>
            ))}
          </View>
        )}
        {reverseScenarioSummaries.length > 0 && (
          <Text style={{ marginTop: 15 }}>
            {translate("scenario.reverseCallScenariosHelp")}
          </Text>
        )}
        {reverseScenarioSummaries.map((s, i) => (
          <View style={style.simpleRemovableWrapper}>
            <Text key={i}>{s}</Text>
          </View>
        ))}
        {irreversibleSummaries.length != 0 && (
          <View style={style.simpleUnremovableWrapper}>
            <View style={{ flexDirection: "row" }}>
              <SimpleIcon
                color={Theme.COLORS.WARNING}
                size={14}
                icon={faExclamationTriangle}
              />
              <Text style={{ color: Theme.COLORS.WARNING }} size={17} bold>
                {" "}
                {translate("scenario.irreversible")}
              </Text>
            </View>
            {irreversibleSummaries.map((s, i) => (
              <View key={i}>
                <Text>
                  {translate("scenario.".concat(s.split(".")[0]))}
                  {" > "}
                  {translate("scenario.".concat(s.split(".")[1]))}
                </Text>
              </View>
            ))}
          </View>
        )}
      </View>
    );
  };

  renderModalInit = (afterDelayConditions = false) => {
    return (
      <View style={{ marginTop: 10 }}>
        <ArButton
          style={style.btnOptionalCondition}
          onPress={() => {
            this.setState({
              modalMode: afterDelayConditions
                ? MODAL_MODES.AreaDeviceStateCheckAfterDelay
                : MODAL_MODES.AreaDeviceStateCheck,
            });
          }}
        >
          <Text>{translate("scenario.sensorStatus")}</Text>
        </ArButton>
        <ArButton
          style={style.btnOptionalCondition}
          onPress={() => {
            var model = new ScenarioModel();
            Object.assign(model, { ...this.state.scenario });
            model
              .addOptionalCondition()
              .addTimeRange(null, null, afterDelayConditions);
            this.setState({ Scenario: model, isModalVisible: false });
          }}
        >
          <Text>{translate("scenario.timeRange")}</Text>
        </ArButton>
        <ArButton
          style={style.btnOptionalCondition}
          onPress={() => {
            this.setState({
              modalMode: afterDelayConditions
                ? MODAL_MODES.areasArmCheckAfterDelay
                : MODAL_MODES.areasArmCheck,
            });
          }}
        >
          <Text>{translate("scenario.areaArmedDisarmed")}</Text>
        </ArButton>
        <ArButton
          style={style.btnOptionalCondition}
          onPress={() => {
            this.setState({
              modalMode: afterDelayConditions
                ? MODAL_MODES.areasUserDefinedStatesAfterDelay
                : MODAL_MODES.areasUserDefinedStates,
            });
          }}
        >
          <Text>{translate("scenario.userDefinedState")}</Text>
        </ArButton>
      </View>
    );
  };

  renderModalAreaList = (title, onSelectCallback) => {
    return (
      <ScrollView>
        <Text style={{ paddingVertical: 10, paddingHorizontal: 10 }}>
          {title}
        </Text>
        <AreaTree
          onlyAdmin={true}
          onSelect={(subId, subUId, subName) => {
            onSelectCallback && onSelectCallback(subId, subUId, subName);
          }}
        />
      </ScrollView>
    );
  };

  renderModalMainDeviceEvent = () => {
    return (
      <MainConditionDeviceGenerator
        areaId={this.state.selectedAreaIdForModal}
        areaUId={this.state.selectedAreaUIdForModal}
        areaName={this.state.selectedAreaNameForModal}
        onConfirm={(deviceEvent) => {
          var model = new ScenarioModel();
          Object.assign(model, { ...this.state.scenario });
          var cModel = new ScenarioDeviceEventCondition();
          Object.assign(cModel, deviceEvent);

          var builder = model.addMainCondition().addDeviceEvent();
          switch (cModel.eventType) {
            case "void":
              builder.addVoidEvent(
                cModel.deviceType,
                cModel.deviceId,
                cModel.deviceUId,
                cModel.deviceName,
                cModel.areaId,
                cModel.areaUId,
                cModel.areaName,
                cModel.listenerName,
                cModel.eventName,
                undefined,
                cModel.parameterNames,
                cModel.parameterValues,
                cModel.parameterTypes
              );
              break;
            case "bool":
              builder.addBooleanEvent(
                cModel.deviceType,
                cModel.deviceId,
                cModel.deviceUId,
                cModel.deviceName,
                cModel.event,
                cModel.eventType,
                true
              );
              break;
            case "byte":
              builder.addRangeEvent(
                cModel.deviceType,
                dcModel.deviceId,
                dcModel.deviceUId,
                cModel.deviceName,
                cModel.event,
                cModel.eventType,
                0,
                255,
                true
              );
              this.setState({
                scenario: model,
                modalMode: MODAL_MODES.conditions,
                isModalVisible: false,
              });
              break;
          }
          // console.log("model in add deviceEvent", model);

          this.setState({
            scenario: model,
            modalMode: MODAL_MODES.none,
            isModalVisible: false,
          });
        }}
      />
    );
  };

  renderModalOptionalDeviceState = (afterDelayCondition = false) => {
    return (
      <OptionalConditionDeviceStateGenerator
        areaId={this.state.selectedAreaIdForModal}
        areaUId={this.state.selectedAreaUIdForModal}
        areaName={this.state.selectedAreaNameForModal}
        onConfirm={(deviceState) => {
          var scenarioModel = new ScenarioModel();
          Object.assign(scenarioModel, { ...this.state.scenario });
          var conditionModel = new ScenarioDeviceStateCondition();
          Object.assign(conditionModel, deviceState);

          scenarioModel
            .addOptionalCondition()
            .addDeviceState(
              conditionModel.areaId,
              conditionModel.areaUId,
              conditionModel.areaName,
              conditionModel.listenerName,
              conditionModel.stateName,
              conditionModel.argNames,
              conditionModel.argValues,
              conditionModel.deviceType,
              conditionModel.deviceId,
              conditionModel.deviceUId,
              conditionModel.deviceName,
              afterDelayCondition
            );

          this.setState({
            scenario: scenarioModel,
            modalMode: MODAL_MODES.none,
            isModalVisible: false,
          });
        }}
      />
    );
  };

  renderModalAreaAction = () => {
    return (
      <View style={{ flex: 1 }}>
        <ActionGenerator
          areaId={this.state.selectedAreaIdForModal}
          areaUId={this.state.selectedAreaUIdForModal}
          areaName={this.state.selectedAreaNameForModal}
          onConfirmAreaState={(actionArea) => {
            var scenarioModel = new ScenarioModel();
            Object.assign(scenarioModel, { ...this.state.scenario });

            var areaStateAction = new ScenarioAreaStateAction();
            Object.assign(areaStateAction, actionArea);

            var autoDisableIntervalDuration = 0;
            var autoDisableIntervalType = this.allIntervalTypes[0];

            var area = this.props.areaReducer.areas.filter(
              (a) =>
                a.areaId == areaStateAction.areaId ||
                a.areaUId == areaStateAction.areaUId
            )[0];
            if (area) {
              var stt = area.userDefinedStates.filter(
                (s) => s.id == areaStateAction.stateId
              )[0];
              if (stt) {
                autoDisableIntervalDuration =
                  stt.autoDisableIntervalDuration || 0;
                autoDisableIntervalType =
                  stt.autoDisableIntervalType || this.allIntervalTypes[0];
              }
            }
            scenarioModel.addAreaStateAction(
              areaStateAction.areaId,
              areaStateAction.areaUId,
              areaStateAction.areaName,
              areaStateAction.stateId,
              areaStateAction.stateUId,
              areaStateAction.stateName,
              areaStateAction.action,
              areaStateAction.manager,
              areaStateAction.shouldOverrideAutoDisable,
              autoDisableIntervalType,
              autoDisableIntervalDuration
            );
            this.setState(
              {
                scenario: scenarioModel,
                //, modalMode : "conditions" , isModalVisible : false
              },
              () => {
                this.toggleModal();
              }
            );
          }}
          onConfirm={(action) => {
            var scenarioModel = new ScenarioModel();
            Object.assign(scenarioModel, { ...this.state.scenario });

            // if (action.manager == "AreaStateManager") {
            //   var areaStateAction = new ScenarioAreaStateAction();

            //   Object.assign(areaStateAction, action);
            //   areaStateAction.stateId = action.deviceId;
            //   areaStateAction.stateUId = action.deviceUId;
            //   areaStateAction.stateName = action.deviceName;

            //   var autoDisableIntervalDuration = 0;
            //   var autoDisableIntervalType = this.allIntervalTypes[0];

            //   var area = this.props.areaReducer.areas.filter(
            //     (a) =>
            //       a.areaId == areaStateAction.areaId ||
            //       a.areaUId == areaStateAction.areaUId
            //   )[0];
            //   if (area) {
            //     var stt = area.userDefinedStates.filter(
            //       (s) => s.id == areaStateAction.stateId
            //     )[0];
            //     if (stt) {
            //       autoDisableIntervalDuration =
            //         stt.autoDisableIntervalDuration || 0;
            //       autoDisableIntervalType =
            //         stt.autoDisableIntervalType || this.allIntervalTypes[0];
            //     }
            //   }

            //   scenarioModel.addAreaStateAction(
            //     areaStateAction.areaId,
            //     areaStateAction.areaUId,
            //     areaStateAction.areaName,
            //     areaStateAction.stateId,
            //     areaStateAction.stateName,
            //     areaStateAction.action,
            //     areaStateAction.shouldOverrideAutoDisable,
            //     autoDisableIntervalType,
            //     autoDisableIntervalDuration
            //   );
            // } else {
            var actionModel = new ScenarioAction();
            Object.assign(actionModel, action);

            scenarioModel.addAction(
              actionModel.areaId,
              actionModel.areaUId,
              actionModel.areaName,
              actionModel.manager,
              actionModel.action,
              actionModel.parameterTypes,
              actionModel.id,
              actionModel.uId,
              actionModel.parameters,
              actionModel.deviceId,
              actionModel.deviceUId,
              actionModel.deviceName,
              actionModel.parametersAlt
            );
            // }
            this.setState(
              {
                scenario: scenarioModel,
                //, modalMode : "conditions" , isModalVisible : false
              },
              () => {
                this.toggleModal();
              }
            );
          }}
        />
      </View>
    );
  };

  renderModalRunScenarioActions = () => {
    return (
      <View style={{ marginHorizontal: 10, flex: 1 }}>
        <Text style={{ fontSize: 14, marginVertical: 10 }}>
          {translate("scenario.runScenarioActionsTitle")}
        </Text>
        <RunScenarioActionPicker
          callerScenarioId={this.state.scenario.id || this.state.scenario.uId}
          onChange={(id, name) => {
            var selectedScenario =
              this.props.scenarioReducer.scenarios.find(
                (s) => s.id == id || s.uId == id
              ) || {};
            let model = new ScenarioModel();
            let { scenario } = this.state;
            Object.assign(model, scenario);
            model.addRunScenarioAction(
              selectedScenario.id || id,
              selectedScenario.uId || id,
              selectedScenario.name || name,
              selectedScenario.reverseEnabled || false
            );
            this.setState({ scenario: model }, () => {
              this.toggleModal();
            });
          }}
        />
      </View>
    );
  };

  renderModalUserDefinedStates = () => {
    var area = AreaHelper.findAreaById(
      this.props.areaReducer.areas,
      this.state.selectedAreaIdForModal || this.state.selectedAreaUIdForModal
    );
    var areaStates = [];
    if (area && Array.isArray(area.userDefinedStates)) {
      areaStates = [...area.userDefinedStates];
    }
    return (
      <View style={{ marginHorizontal: 10, flexDirection: "row", flex: 1 }}>
        <ScrollView style={{ flex: 1 }}>
          <Text>{this.state.selectedAreaNameForModal}</Text>
          <SearchableDropDown
            clearable={true}
            items={areaStates.map((stt) => {
              return { id: stt.id || stt.uId, name: stt.name };
            })}
            searchText={translate("app.selectAnItem")}
            //selectedValue={this.props.selectedScenarioId}
            onSelect={(stateId, stateName) => {
              var _stateId = {
                stateId: 0,
                stateUId: null,
              };
              if (typeof stateId == "number") {
                _stateId.stateId = stateId;
              } else {
                _stateId.stateUId = stateId;
              }
              let model = new ScenarioModel();
              let { scenario } = this.state;
              Object.assign(model, scenario);
              model
                .addOptionalCondition()
                .addAreaUserDefinedState(
                  this.state.selectedAreaIdForModal,
                  this.state.selectedAreaUIdForModal,
                  this.state.selectedAreaNameForModal,
                  _stateId.stateId,
                  _stateId.stateUId,
                  stateName,
                  this.state.selectedAfterDelayConditionForModal
                );

              this.setState(
                {
                  scenario: model,
                  selectedAreaIdForModal: 0,
                  selectedAreaUIdForModal: null,
                  selectedAreaNameForModal: "",
                  selectedAfterDelayConditionForModal: false,
                },
                () => {
                  this.toggleModal();
                }
              );
            }}
          />
        </ScrollView>
      </View>
    );
  };

  renderModalSummary = () => {
    return (
      <View style={{ flex: 1 }}>
        <ScenarioSummary
          style={{ flex: 1 }}
          model={this.state.scenario}
          scenarioId={0} // send id 0 to force ScenarioSummary component using 'props.model' instead of retrieving from reducer
          scenarioUId=""
          hasDetail={this.state.scenario.hasDetail}
          actionReverseDictionary={this.getActionReverseDictionary()}
          enable={true}
        />
        <View style={{ marginTop: 10 }}>
          <ArButton
            color="primary"
            onPress={() => {
              this.save();
            }}
            style={{ width: "100%" }}
          >
            {translate("app.save")}
          </ArButton>
          <ArButton
            color="muted"
            onPress={() => {
              this.setState({
                modalMode: MODAL_MODES.none,
                isModalVisible: false,
              });
            }}
            style={{ width: "100%", marginBottom: 0 }}
          >
            {translate("app.edit")}
          </ArButton>
        </View>
      </View>
    );
  };
}

/**@augments{Component<props,state>} */
class SimpleRemovableItem extends Component {
  static propTypes = {
    text: PropTypes.string,
    onDelete: PropTypes.func,
  };

  render() {
    return (
      <View style={style.simpleRemovableWrapper}>
        <View style={{ flex: 1 }}>
          <Text>{this.props.text}</Text>
        </View>
        <TouchableHighlight
          underlayColor="transparent"
          style={style.btnRemove}
          onPress={() => {
            this.props.onDelete && this.props.onDelete();
          }}
        >
          <FontAwesomeIcon
            icon={faTrash}
            color={Theme.COLORS.ERROR}
            size={16}
          />
        </TouchableHighlight>
        {/* <View style={{ marginHorizontal: 10, paddingTop: 1 }}> */}
        {/* <ArButton
            color="error"
            style={{ width: 35, height: 35 }}
            onPress={() => {
              this.props.onDelete && this.props.onDelete();
            }}
          >
            <FontAwesomeIcon icon={faTrash} color="#FFF" size={16} />
          </ArButton> */}
        {/* </View> */}
      </View>
    );
  }
}

const style = StyleSheet.create({
  container: {
    //paddingTop: 10,
    paddingHorizontal: 10,
  },
  simpleRemovableWrapper: {
    flexDirection: "row",
    marginVertical: 5,
    padding: 5,
    alignItems: "center",
    borderColor: Theme.COLORS.BORDER_COLOR,
    borderWidth: 2,
    borderRadius: 10,
    minHeight: 50,
    backgroundColor: Theme.COLORS.WHITE,
  },
  simpleUnremovableWrapper: {
    //flexDirection: "row",
    marginVertical: 5,
    padding: 5,
    //alignItems: "center",
    borderColor: Theme.COLORS.BORDER_COLOR,
    borderWidth: 2,
    borderRadius: 10,
    minHeight: 60,
    backgroundColor: Theme.COLORS.WARNING + "22",
  },
  inputLabel: {
    fontWeight: "500",
    fontSize: 15.4,
    marginBottom: 4,
  },
  mainConditionWrapper: {
    paddingBottom: 10,
    marginBottom: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
    marginBottom: 15,
  },
  optionalConditionAddButton: {
    minWidth: 120,
    height: 40,
    alignSelf: "flex-start",
    marginLeft: 5,
    marginTop: 15,
  },
  modalInsideWrapper: {
    flex: 1,
    padding: 10,
    height: "100%",
  },
  btnOptionalCondition: {
    width: "100%",
    backgroundColor: Theme.COLORS.THIRED,
  },
  modalButton: {
    width: "100%",
    marginBottom: 0,
    marginTop: 5,
  },
  areaSelectItem: {
    padding: 5,
    marginVertical: 1,
    marginHorizontal: 5,
    borderRadius: 3,
    height: 42,
    backgroundColor: "#9C26B050",
  },
  lightDropDown: {},
  iosRtl: {
    textAlign: Platform.OS == "ios" ? "left" : "auto",
  },
  btnRemove: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fee6eb",
    borderRadius: 10,
    padding: 1,
    width: 40,
    height: 40,
    shadowColor: Theme.COLORS.INPUT,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
});

const mapStateToProps = (state) => {
  return {
    deviceReducer: state.DeviceReducer,
    areaReducer: state.AreaReducer,
    scenarioReducer: state.ScenarioReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (scenario, accessToken) =>
      dispatch(Actions.Add(scenario, accessToken)),
    // update: (device, accessToken) =>
    //   dispatch(Actions.Update(device, accessToken))
    //remove: deviceId => dispatch(Actions.Remove(deviceId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioFormScreen);
